import React, { Component } from 'react';
import { PageLayout, ContentTemplate } from '../../common/components/layout';
import values from './configs/values';
import { service } from '../../common/configs';

class Teacher extends Component {
  constructor(props) {
    super(props);

    const { type } = this.props;
    this.onClickButton = this.onClickButton.bind(this);

    this.state = {
      contentsValues: values.CONTENTS[type],
    };
  }

  componentDidUpdate(prevProps, prevState) {
    const { type } = this.props;
    if (type !== prevProps.type) {
      this.setState({
        contentsValues: values.CONTENTS[type],
      });
    }
  }

  onClickButton(e) {
    e.preventDefault();
    const { contentsValues } = this.state;
    window.open(contentsValues.link, '_blank');
  }

  onClickRecruitButton(e) {
    e.preventDefault();
    const { contentsValues } = this.state;
    window.open(contentsValues.recruitLink, '_blank');
  }

  getTeacherType() {
    const { type } = this.props;
    if (type === values.TEACHER_TYPE.promotionTeacher) {
      return 'promotion';
    }
    return '';
  }

  renderTitle() {
    const { contentsValues } = this.state;
    return (
      <h4 className="recruit-title">
        <span>{contentsValues.title}</span>
      </h4>
    );
  }

  renderContents() {
    const { contentsValues } = this.state;
    return Array.from({ length: contentsValues.imgCount }).map((_, idx) => {
      const imageUrl = service.getRecentModifiedImageUrl(
        idx + 1,
        contentsValues
      );
      const isButton = (contentsValues?.buttonIndex ?? []).indexOf(idx) >= 0;
      return (
        <div
          className={`contents-container ${
            contentsValues.imgCount - 1 === idx ? 'last-item' : ''
          }`}
          style={{ backgroundColor: contentsValues.backgroundColors[idx] }}
          key={idx}
        >
          <div className="content-item">
            <div className={`content-${idx + 1}`}>
              <img src={imageUrl} alt="" />
            </div>
            {isButton && this.renderButton()}
          </div>
        </div>
      );
    });
  }

  renderButton() {
    const { contentsValues } = this.state;
    return (
      <div
        className="button"
        style={contentsValues.buttonStyle}
        onClick={this.onClickButton.bind(this)}
      >
        <img src={contentsValues.button} alt="" />
      </div>
    );
  }

  renderRecruitButton() {
    const { contentsValues } = this.state;

    if (!contentsValues.recruitButton) {
      return null;
    }

    return (
      <div
        className="recruit-button"
        onClick={this.onClickRecruitButton.bind(this)}
      >
        <img src={contentsValues.recruitButton} alt="" />
      </div>
    );
  }

  render() {
    return (
      <PageLayout>
        <ContentTemplate>
          <div className={`teacher-container ${this.getTeacherType()}`}>
            {this.renderTitle()}
            {this.renderContents()}
            {this.renderRecruitButton()}
          </div>
        </ContentTemplate>
      </PageLayout>
    );
  }
}

export default Teacher;
